module.exports = __webpack_public_path__ + "static/media/invoices.62c82129.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/invoices.png
// module id = 21
// module chunks = 0